import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Icon } from "@qgiv/core-react";
import Divider from "../Divider";

const SummarySectionContainer = ({
    displayCount = false,
    displayIcon = false,
    sectionCount = 0,
    sectionName = "",
    hasActionButton = false,
    renderActionButton = () => {},
    iconGlyph,
    iconType,
    children,
    bottomMargin = "",
}) => (
    <div className="col col--12">
        {/* eslint-disable-next-line tailwindcss/classnames-order */}
        <div className="grid grid--no--gutter">
            <div className="col col--8">
                <small>
                    {displayIcon && iconType && iconGlyph && (
                        <Icon
                            className="-margin-right--10"
                            glyph={iconGlyph}
                            type={iconType}
                        />
                    )}
                    <strong className="-text-transform--uppercase">
                        {sectionName}
                    </strong>
                    {displayCount && sectionCount > 0 && (
                        <strong>{` x ${sectionCount}`}</strong>
                    )}
                </small>
            </div>
            {hasActionButton && (
                <div className="col col--4 -text--right">
                    <small>
                        {/* Passed in render action button  */}
                        {renderActionButton()}
                    </small>
                </div>
            )}
        </div>
        <Divider
            classNames={cx(
                "registration-summary__divider",
                bottomMargin && `-margin-bottom--${bottomMargin}`,
            )}
        />
        {children}
    </div>
);

SummarySectionContainer.propTypes = {
    bottomMargin: PropTypes.string,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]).isRequired,
    displayCount: PropTypes.bool,
    displayIcon: PropTypes.bool,
    hasActionButton: PropTypes.bool,
    iconGlyph: PropTypes.string.isRequired,
    iconType: PropTypes.string.isRequired,
    renderActionButton: PropTypes.func,
    sectionCount: PropTypes.number,
    sectionName: PropTypes.string.isRequired,
};

export default SummarySectionContainer;
